import React, { useRef } from 'react';
import { generatePDF } from '../../../utils/reportUtils';
import { useTranslation } from 'react-i18next';
import ReportDialog from '../../../components/Reports/ReportDialog';
import { SalesReturn } from './SalesReturnHelper';
import SalesReturnReportPreview from './SalesReturnReportPreview';

type Props = {
  open: boolean;
  onClose: () => void;
  data: SalesReturn | null;
};

const SalesReturnReport: React.FC<Props> = ({ open, onClose, data }) => {
  const reportRef = useRef<HTMLDivElement>(null);
  const { t: tGeneral } = useTranslation('general');
  const { t } = useTranslation('sales_return');

  const handleDownloadPDF = () => {
    if (reportRef.current) {
      generatePDF(reportRef.current, t('Report_Title'));
    }
  };

  const handlePrint = () => window.print();

  return (
    <ReportDialog
      open={open}
      onClose={onClose}
      title={t('Report_Title')}
      onDownload={handleDownloadPDF}
      onPrint={handlePrint}
      downloadLabel={tGeneral('DownloadReport', { defaultValue: 'Download Report' })}
      printLabel={tGeneral('PrintReport', { defaultValue: 'Print Report' })}
    >
      <div ref={reportRef}>
        <SalesReturnReportPreview reportData={data} />
      </div>
    </ReportDialog>
  );
};

export default SalesReturnReport;
